// Paths that must render without a Keycloak login (keycloak.json uses onLoad:
// "login-required", so initializing on these paths would redirect to the SSO).
// Used by main.js (skip keycloak.init), App.vue (skip loadMe + apply the
// centered `.container.public` layout).
export const publicPaths = [
  '/logout',
  '/lerngruppen-login',
  '/lerngruppen-login/anmelden',
  '/lerngruppen-login/passwort',
  '/lerngruppen-login/email',
  '/lerngruppen-login/geschafft'
]

// isPublicPath strips trailing slashes before comparing: nginx serves the SPA
// for `/klassen-login/` too (no redirect) and vue-router matches it non-strict,
// so an exact includes() would miss it and fall through to the Keycloak login.
export function isPublicPath (path) {
  return publicPaths.includes(path.replace(/\/+$/, '') || '/')
}
